import moment from 'moment'
import { IImageZoneReport } from '../../../types/image-zone'
import { styles } from '../styles'
import { Text, View } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'

const CommentsBox = ({ imageZone }: { imageZone: IImageZoneReport }) => {
  const { t } = useTranslation()
  return (
    <View>
      {imageZone.comments.length > 0 ? (
        <View style={styles.leftBorder}>
          {imageZone.comments.map((comment) => (
            <View key={comment.id} style={styles.cardContainer}>
              <View style={styles.flexContainer}>
                <Text
                  style={[styles.smallText, styles.boldText, styles.smallMb]}
                >
                  {t('shared.common.dr')}{' '}
                  {comment.owner?.contactName || 'Unknown'}
                </Text>
                <Text style={[styles.smallText, styles.lightGrayText]}>
                  {moment(comment.createdAt).format('DD/MM/YYYY HH:mm')}
                </Text>
              </View>
              <Text style={styles.text}>{comment.commentText}</Text>
            </View>
          ))}
        </View>
      ) : (
        <Text style={{ ...styles.lightGrayText, fontStyle: 'italic' }}>
          {t('sharedDiagnostic.comments.noComments')}
        </Text>
      )}
    </View>
  )
}

export default CommentsBox
